import { PropsWithChildren } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { ExpandableContent } from "@/components/wpl/expandable-content";

const dataCenterSectionContainer = css({
    "width": "100%",
    "background": "#FAFBFC",
    "padding": "1rem",
    "boxShadow":
        "0px 3px 5px 0px rgba(9, 30, 66, 0.20), 0px 0px 1px 0px rgba(9, 30, 66, 0.31)",

    "& h2": {
        fontSize: "1rem",
        lineHeight: "1.5rem",
        margin: 0
    },

    "& p, span": {
        fontSize: "0.875rem",
        lineHeight: "1.5rem"
    },

    "@media (min-width: 768px)": {
        "maxWidth": "56.875rem",
        "padding": "1.5rem",

        "> h2": {
            fontSize: "1.25rem"
        },

        "& p, span": {
            fontSize: "1rem"
        }
    }
});

export const DataCenter = (props: PropsWithChildren) => {
    return (
        <div css={dataCenterSectionContainer}>
            <h2>
                <FormattedMessage
                    id="Pricing.priceFinder.dataCenterSectionHeader"
                    defaultMessage="Pricing for Data Center"
                />
            </h2>
            <p>
                <FormattedMessage
                    id="Pricing.priceFinder.dataCenterSectionText"
                    defaultMessage="Scale your teams while maintaining control of your environment with Atlassian Data Center, our self-managed option."
                />
            </p>
            <ExpandableContent
                eventDataName="datacenter_show_more"
                label={
                    <span>
                        <FormattedMessage
                            id="Pricing.priceFinder.dataCenterSectionShowMore"
                            defaultMessage="Show more"
                        />
                    </span>
                }
                expandedLabelText={
                    <span>
                        <FormattedMessage
                            id="Pricing.priceFinder.dataCenterSectionShowLess"
                            defaultMessage="Show less"
                        />
                    </span>
                }
                labelCss={{ color: "#0065FF" }}
            >
                {props.children}
            </ExpandableContent>
        </div>
    );
};
